import type {
    ComposableOptionsBase
} from '~/types';
import {
    VisibilityRole
} from '~/types';

export interface UseVisibilityRolesOptions extends ComposableOptionsBase {}
export function useVisibilityRoles(options: Partial<UseVisibilityRolesOptions> = {}) {
    const nuxtApp = useNuxtApp();
    const {
        entityType,
        currentMembership
    } = nuxtApp.$user;

    const entityName = computed(() => currentMembership.value?.entity?.name || entityType.value);
    const showVisibilityToggle = computed(() => entityType.value === 'team' || entityType.value === 'org');
    const entityVisibilityRole = computed(() =>
        entityType.value === 'team' ? VisibilityRole.TEAM : VisibilityRole.ORG
    );

    return {
        entityName,
        showVisibilityToggle,
        entityVisibilityRole
    };
}
